import { WarehouseLocationsMenu } from "@/components/stock";
import { WarehouseLocations } from "../../warehouse-locations";
import type { WarehouseZonePanelBaseProps } from "../shared";

/**
 * The shelves standing in one hall, on a tab of their own.
 *
 * It is the same table the zones list expands into, narrowed to this zone — so what a shelf shows
 * and what it expands into are decided in one place rather than re-specified per screen.
 *
 * A tab rather than a column beside the facts, because the two are read at different moments and
 * at different sizes: the general tab answers "what is this hall and where is its label", which
 * fits a card, while this is a table somebody works through and wants the width for.
 */
export function WarehouseZoneLocations({ warehouseZoneId }: WarehouseZonePanelBaseProps) {
	/** Render */
	return (
		<WarehouseLocations
			query={{ warehouseZoneId }}
			menu={<WarehouseLocationsMenu query={{ warehouseZoneId }} />}
		/>
	);
}
